<template>
  <div class="modal-content">
      <resource-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:deleteResource="deleteResource" v-on:close="hideModal" v-on:save="save" class-name="modal-body" />
  </div>
</template>

<script>

import { ResourceDetails } from '#components'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (resource) {
      this.$emit('save', resource)
    },
    deleteResource (resource) {
      this.$emit('deleteResource', resource)
    }
  },
  components: {
    ResourceDetails
  }
}

</script>